// extracted by mini-css-extract-plugin
module.exports = {"custombutton":"adesao_formulario_documentos_custombutton__30h7h","btn":"adesao_formulario_documentos_btn__1So_Z","ajuste":"adesao_formulario_documentos_ajuste__2J6r4"};